<template>
  <LayoutPublic>
    <NavBarPublic />
    <HeroSection :data-hero="dataHero" />
    <ListLayananSection />
    <FooterPublic />
  </LayoutPublic>
</template>

<script>

import LayoutPublic from '../../../views/layouts/Public.vue'
import NavBarPublic from '../../../components/layout/NavBarPublic.vue'
import HeroSection from '../../../components/layout/HeroSection.vue'
import ListLayananSection from '../../../components/layout/ListLayananSection.vue'
import FooterPublic from '../../../components/layout/FooterPublic.vue'

export default {
	name: 'App',
	data(){
		return {
			dataHero: {
				title: 'Layanan Dokumen Kependudukan Aplikasi SiPeDuLi Jembrana',
				desc: 'Berbagai jenis permohonan terkait dokumen kependudukan tersedia di Aplikasi SiPeDuLi Jembrana',
				action: 'daftar',
				img: 'home'
			}
		}
	},
	computed: {
		selectedPaket(){
			return this.$store.getters.getSelectedPaket // di fetch di listlayanansection. biar sekali aja
		}
	},
	components: {
		LayoutPublic, NavBarPublic, HeroSection, ListLayananSection, FooterPublic
	},
	methods: {
			
	},
	created(){
			
	},
	mounted(){
		document.querySelector('body').scrollIntoView()
	},
	watch: {
		selectedPaket(newVal){
			this.dataHero.title = newVal.nama_paket
			this.dataHero.desc = newVal.deskripsi_paket
		}
	}
}
</script>

<style>

</style>
